import { render, staticRenderFns } from "./BaseVoteTicket.vue?vue&type=template&id=3d0236a8"
import script from "./BaseVoteTicket.vue?vue&type=script&lang=js"
export * from "./BaseVoteTicket.vue?vue&type=script&lang=js"
import style0 from "./BaseVoteTicket.vue?vue&type=style&index=0&id=3d0236a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports